import React from 'react';
import {useToasts} from 'features/notifications/useToasts';
import {getErrors} from 'redux/common';
import {useDispatch} from 'react-redux';
import {action} from 'redux/helpers';
import {loginTypes} from 'features/login/redux';

type Props = {
   url?: string;
   setError?: (err: any) => void;
   setLoading?: (loading: boolean) => void;
   hideToast?: boolean;
};
export const useHandleApiError = ({url, setError, setLoading, hideToast}: Props) => {
   const {addToast} = useToasts();

   const dispatch = useDispatch();

   const handler = React.useCallback(
      (callback?: (e: Response, message: string) => void, _url?: string) => (e: Response) => {
         return getErrors(e, _url || url).then(({message, error}) => {
            // console.debug(message);
            // console.debug(error);
            if (e.status === 401) {
               dispatch(action(loginTypes.LOGIN.ERROR, e));
            }
            setError?.(error);
            setLoading?.(false);
            callback?.(error, message);
            !hideToast && addToast(message, {appearance: 'error'});
         });
      },
      [url, setError, setLoading, addToast]
   );

   return handler;
};
